export const ScreenSize = {
  MobileMedium: 540,
  Tablet: 770,
  DesktopNarrow: 890,
  DesktopAlmostMediumSmall: 1132,
  DesktopMediumSmall: 1180,
  DesktopMedium: 1440,
};
